import React from 'react';
import Img_logo from '../images/fp-post.jpeg';


export default () => (
	<div className='section3-CN'>

		<div class="service-split">
			<img class="service-split-img" src={Img_logo}></img>
			<div>
				<h4>
					Post-Construction
				</h4>
				<p>
					15. Operations, Management & Exit Strategy Support:
					After the building is complete, we can stay involved by helping you set up rental management, stay on as property managers, or prepare the asset for refinancing or sale through our recommended financial broker channels… whatever best fits your long-term strategy as a landowner or capital holder.
				</p>
			</div>
		</div>

	</div>
);
